/**
 * StatBlock — mirrors aidea.templateengine/src/slides/components/StatBlock
 * Renders a single KPI metric: value, optional unit, label, optional detail.
 */
import React from "react";

/* eslint-disable react/prop-types */

export function StatBlock({ value, unit, label, detail }) {
  return (
    <div className="atomic-stat-block" style={{ display: "grid", gap: "var(--space-1)" }}>
      {/* Value row */}
      <div style={{ display: "flex", alignItems: "baseline", gap: "var(--space-1)" }}>
        <span
          style={{
            fontFamily: "var(--font-heading)",
            fontWeight: "var(--font-display-weight)",
            fontSize: "var(--text-3xl)",
            color: "var(--color-text-primary)",
            lineHeight: 1,
          }}
        >
          {value}
        </span>
        {unit && (
          <span
            style={{
              fontFamily: "var(--font-body)",
              fontSize: "var(--text-md)",
              color: "var(--color-text-accent)",
              fontWeight: 600,
            }}
          >
            {unit}
          </span>
        )}
      </div>

      {/* Label */}
      <span
        style={{
          fontFamily: "var(--font-body)",
          fontSize: "var(--text-sm)",
          color: "var(--color-text-secondary)",
          lineHeight: 1.4,
        }}
      >
        {label}
      </span>

      {/* Detail */}
      {detail && (
        <span
          style={{
            fontFamily: "var(--font-body)",
            fontSize: "var(--text-xs)",
            color: "var(--color-text-muted)",
          }}
        >
          {detail}
        </span>
      )}
    </div>
  );
}

export default StatBlock;
